import { ImgHTMLAttributes, useEffect, useState } from "react";
import { MASCOT_MAP, MascotName, MascotVariant } from "./assets";
import {
  MascotDropShadow,
  MascotImage,
  MascotSize,
} from "./MascotFeedback.styles";

type BaseImgProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  "src" | "width" | "height" | "alt" | "aria-hidden"
>;

type MascotAccessibilityProps =
  | {
    decorative: true;
    alt?: never;
    "aria-hidden"?: never;
    "aria-label"?: never;
  }
  | {
    decorative?: false;
    alt: string;
  };


export type MascotFeedbackProps = BaseImgProps &
  MascotAccessibilityProps & {
    variant: MascotVariant;
    name: MascotName;
    size?: MascotSize;
    dropShadow?: MascotDropShadow;
    interactive?: boolean;
  };

export const MascotFeedback = ({
  variant,
  name,
  alt,
  decorative = false,
  size = "md",
  dropShadow = "none",
  interactive = false,
  onError,
  ...rest
}: MascotFeedbackProps) => {
  const src = MASCOT_MAP[variant][name];
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  if (hasError) return null;

  return (
    <MascotImage
      $size={size}
      $dropShadow={dropShadow}
      $interactive={interactive}
      src={src}
      alt={decorative ? "" : alt}
      aria-hidden={decorative ? true : undefined}
      loading="lazy"
      decoding="async"
      onError={(e) => {
        setHasError(true);
        onError?.(e);
      }}
      {...rest}
    />
  );
};
